module.exports = {render: function () {with(this){return _c('svg',{staticClass:"slide-arrow",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-12285.993 -14134.072 23.544 41.422","width":"19","height":"38"}},[_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"id":"Path_184","data-name":"Path 184","d":"M-16549.963-12306.885l19.3 19.3 19.3-19.3","transform":"rotate(-90 -15310.86 -15333.166)"}})])}}};


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow-right.svg
// module id = cXxo
// module chunks = 0